import React from 'react'
import profile from '../assets/profile.jpg'
import ft from '../assets/recycnetai.png'

function Home() {

  const latestProject = {
    title: "Recycnet AI",
    description: "Recycnet AI is a deep learning-powered web app that classifies uploaded waste images into four categories.",
    image: ft,
    link: "https://github.com/iam-tarun/Recycnet-AI"
  };


  return (
    <div id='home' className='grid'>
      
        <img className='profile-pic' src={profile} alt="tarun teja profile pic" />

        <h1>Hi, I'm Tarun — I build intelligent web applications.</h1>
        <h2 className='home-heading' >AI/ML Engineer | Full Stack Developer </h2>
        {/* short intro of me */}
        
      
      <div className='CTA' >
        <h2 >Latest Project</h2>
        <div className='cta-image-wrapper' >
        <img src={latestProject.image} alt={latestProject.title}  />
        </div>
        <h3 className='CTA-title' >{latestProject.title}</h3>
        <p className="leading">{latestProject.description}</p>
      </div>
      <a className='a-button' style={{textDecoration: 'none', color: '#e4e4e5'}} href="./projects"><button className='button'  >
        View My Work
      </button></a>
    </div>
  
  )
}

export default Home